import { LabelButton } from '@teamsnap/snap-ui';
import { NewInvoice } from 'components/invoices';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';

type RouteParams = { orgId: string; formId: string };

const Registration: React.FC<RouteComponentProps<RouteParams>> = ({
  match: {
    params: { orgId },
  },
}) => {
  const { useState } = React;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div id="programs" className="container hub-full-width">
      <div className="page-content sui-p-2 t:sui-p-4">
        <div className="page-content-header sui-flex sui-flex-col t:sui-flex-row t:sui-items-center">
          <div className="sui-w-full t:sui-w-1/2">
            <h1 data-testid="registration-heading">Invoices</h1>
          </div>

          <div className="sui-w-full sui-flex t:sui-w-1/2 t:sui-justify-end">
            <LabelButton icon="add" iconPosition="left" labelText="New Invoice" onClick={() => setIsOpen(!isOpen)} />
          </div>

          {isOpen && <NewInvoice orgId={orgId} setIsOpen={setIsOpen} />}
        </div>
        This is the list of invoice batches for the organization
      </div>
    </div>
  );
};

export default Registration;
